module.exports = __webpack_public_path__ + "static/media/activate-banner.fdd88183.png";